import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';

import useAppSelector from 'hooks/useAppSelector';
import EditLinkPluginModal from './EditLinkPluginModal';
import { EditLinkPluginModalFormValues } from './EditLinkPluginModal.schema';

const modalId = 'edit-link-modal';

const useEditLinkPluginModal = () => {
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openEditLinkModal = ({
    defaultValues,
    onSubmit,
  }: {
    defaultValues: EditLinkPluginModalFormValues;
    onSubmit: (args: EditLinkPluginModalFormValues) => void;
  }) => {
    openModal({
      customContent: (
        <EditLinkPluginModal
          defaultValues={defaultValues}
          onSubmit={onSubmit}
        />
      ),
      id: modalId,
      title: t('form.editor.link.title'),
    });
  };

  return {
    openEditLinkModal,
    isEditLinkModalOpen: !!activeModals[modalId],
  };
};

export default useEditLinkPluginModal;
